<template>
  <!-- 主要内容 begin -->
  <div id="content-main">
    <!-- 搜索 start -->
    <div class="flex-between" style="flex-flow:row wrap;">
      <div class="flex-start" style="margin-bottom:5px;">
        <div class="search-item">
          <a-input-search
            v-model="keyword"
            placeholder="搜索成员 名称或手机号"
            style="width: 200px"
            @search="search"
          />
        </div>
      </div>
      <div>
        <a-button @click="modalStatus_1('')" type="primary" icon="plus"
          >创建管理员</a-button
        >
      </div>
    </div>
    <a-divider dashed />
    <!-- 搜索 end -->

    <!-- 列表 start -->
    <a-row :gutter="16">
      <a-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="8"
        style="margin-top:16px;"
        :key="index"
        v-for="(item, index) in list"
      >
        <a-card style="position:relative;">
          <div class="flex-between">
            <div class="flex-start">
              <a-avatar
                size="large"
                :src="`${item.photo ? qiniuURL + item.photo.fields.url : ''}`"
                icon="user"
              />
              <div style="margin-left:20px;">
                <div>
                  {{ item.user.fields.username }}
                  <a-tag v-if="item.user.fields.status" color="green"
                    >启用</a-tag
                  >
                  <a-tag v-else color="red">禁用</a-tag>
                </div>
                <div>{{ item.user.fields.phone }}</div>
              </div>
            </div>
            <div>
              <div>
                {{ item.group.fields.name }}
              </div>
              <div><a @click="modalStatus_1(item)">编辑</a></div>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <!-- 列表 end -->

    <!-- 分页 -->
    <Pagination :current="current" :pageSize="pageSize" :total="total" />

    <!-- 弹出层 start -->
    <a-modal
      :title="modalName_1 ? '编辑管理员' : '创建管理员'"
      :visible="modalVisible_1"
      @ok="modalSubmit_1"
      :confirmLoading="modalLoading_1"
      @cancel="modalStatus_1"
    >
      <a-form :form="modelForm_1">
        <a-form-item
          label="头像"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-upload
            v-decorator="[
              `photo`,
              {
                valuePropName: 'fileList',
                getValueFromEvent: uploadFile,
                rules: [{ required: false, message: '必填项' }],
                initialValue: photoTurn(photo)
              }
            ]"
            name="file"
            action="/api/qiniu/upload"
            list-type="picture"
          >
            <a-button>
              <a-icon type="cloud-upload" style="color:#FFB6B8" /> 选择文件
            </a-button>
          </a-upload>
        </a-form-item>

        <a-form-item
          label="账户名"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            v-decorator="[
              'username',
              {
                rules: [{ required: true, message: '必填项' }],
                initialValue: modalName_1 && modalName_1.user.fields.username
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="手机号"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [{ required: true, message: '必填项' }],
                initialValue: modalName_1 && modalName_1.user.fields.phone
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="用户组"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            v-decorator="[
              'group',
              {
                rules: [{ required: true, message: '必填项' }],
                initialValue: modalName_1 ? modalName_1.user.fields.group : []
              }
            ]"
          >
            <a-select-option v-for="item in groupList" :key="item.pk">{{
              item.fields.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="状态"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-radio-group
            v-decorator="[
              'status',
              {
                rules: [{ required: true, message: '必填项' }],
                initialValue: modalName_1
                  ? modalName_1.user.fields.status
                    ? 1
                    : 0
                  : 1
              }
            ]"
          >
            <a-radio :value="1">
              启用
            </a-radio>
            <a-radio :value="0">
              禁用
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="密码"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            v-decorator="[
              'password',
              { rules: [{ required: false, message: '必填项' }] }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 弹出层 end -->
  </div>
  <!-- 主要内容 end -->
</template>

<script>
import Pagination from "../../admin/components/Pagination";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      // 数据
      list: [],
      groupList: [],
      // 查询参数
      total: 0,
      current: 1,
      pageSize: 20,
      keyword: "",
      // 弹出层
      modalLoading_1: false,
      modalVisible_1: false,
      modalName_1: "",
      modelForm_1: this.$form.createForm(this, { name: "modalForm_1" }),
      photo: null
    };
  },
  created() {
    this.init();
    this.getList();
  },
  methods: {
    // 初始化
    init() {
      this.api.getSystemGroupList({}, res => {
        if (res.success) {
          this.groupList = res.data.list;
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    },
    // 刷新
    refresh() {
      this.pageSize = 20;
      this.current = 1;
      this.keyword = null;
      this.getList();
    },
    // 重新赋值登录用户信息
    getManagerInfo() {
      this.api.getManagerInfo({}, res => {
        if (res.success) {
          let permissions = [];
          for (let i = 0; i < res.data.permissions.length; i++) {
            permissions.push(res.data.permissions[i].fields.name);
          }
          console.log(permissions);
          res.data.user["permissions"] = permissions;
          res.data.user["photo"] = res.data.photo;
          res.data.user["group"] = res.data.group;
          this.$store.dispatch("setToken", res.data.user.fields.accessToken);
          this.$store.dispatch("setUser", res.data.user);
        }
      });
    },
    // 查询
    search() {
      this.current = 1;
      this.getList();
    },
    // 列表方法
    getList() {
      this.loading = true;
      let params = {
        limit: this.pageSize,
        current: this.current,
        keyword: this.keyword
      };
      this.api.getSystemManagerList(params, res => {
        this.loading = false;
        if (res.success) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    },
    // 分页方法
    handleTableChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    // 弹出层
    modalStatus_1(record = null) {
      this.modelForm_1.resetFields();
      this.modalVisible_1 = !this.modalVisible_1;
      this.modalName_1 = this.modalVisible_1 ? record : null;
      this.photo = this.modalVisible_1 ? record.photo : null;
    },
    modalSubmit_1() {
      this.modelForm_1.validateFields((err, values) => {
        this.modalLoading_1 = true;
        if (err) {
          this.modalLoading_1 = false;
          return;
        }

        let photo_id = "";
        if (values["photo"] && values["photo"].length > 0) {
          for (let i = 0; i < values["photo"].length; i++) {
            photo_id = values["photo"][i].response.data.id;
          }
        }
        values["photo"] = photo_id;
        if (this.modalName_1 && this.modalName_1.pk) {
          values["id"] = this.modalName_1.pk;
          this.api.updateSystemManager(values, res => {
            this.modalLoading_1 = false;
            if (res.success) {
              this.modalStatus_1();
              this.getList();
              this.getManagerInfo();
            } else {
              this.$notification.error({
                message: "错误警告！",
                description: res.message
              });
            }
          });
        } else {
          this.api.createSystemManager(values, res => {
            this.modalLoading_1 = false;
            if (res.success) {
              this.modalStatus_1();
              this.getList();
            } else {
              this.$notification.error({
                message: "错误警告！",
                description: res.message
              });
            }
          });
        }
      });
    },
    uploadFile(e) {
      console.log("Upload event:", e);
      // return e.file.response.fileDownloadUri
      if (Array.isArray(e.fileList)) {
        console.log("isarray");
        return e.fileList;
      }
      return [];
      // return e && e.fileDownloadUri;
      // let list = []
      // for(let i=0; i<e.fileList.length; i++){
      //   list.push(e.fileList[i])
      // }
      // return list;
    },
    photoTurn(photo) {
      const list = [];
      console.log(photo);
      if (photo) {
        list.push({
          name: photo.fields.name,
          response: { data: { id: photo.pk } },
          url: this.qiniuURL + photo.fields.url,
          status: "done",
          uid: ""
        });
      }
      console.log(list);
      return list;
    }
  }
};
</script>
